/**
 * Escala de empilhamento da interface. Manter os valores aqui evita que duas
 * camadas diferentes usem o mesmo z-index e passem a depender da ordem do DOM
 * para decidir quem fica na frente.
 */
export const CAMADAS = {
  /** Cabeçalho fixo de tabela, que só precisa vencer as linhas que rolam sob ele. */
  cabecalhoFixo: 1,
  /** Balão do informativo do dashboard, por cima da grade de quadros. */
  balao: 20,
  /** Aviso do filtro, ancorado abaixo do campo: passa por cima do balão. */
  avisoDeFiltro: 30,
  /** Lista aberta de um filtro: fica acima de qualquer aviso da mesma barra. */
  listaDeFiltro: 40,
  /** Barra do modo TV, fixa no rodapé por cima da grade; abaixo de gaveta e modais. */
  barraTv: 50,
  /** Gaveta da navegação em tela estreita, e o fundo escuro logo abaixo dela. */
  gaveta: 900,
  /** Modais de conteúdo: detalhes do dashboard, remoção/instalação, imagens. */
  overlay: 1000,
  /** Confirmações: precisam ficar acima de qualquer modal já aberto. */
  confirmacao: 1100,
} as const;
